import {useSelector} from "react-redux";

const useSession = () => {

    const { session } = useSelector(
        state => state.local.auth
    )

    const getIsSignedIn = () => {
        return Boolean(session?.bPartnerID);
    }

    const getUserName = () => {
        return session?.userName;
    }

    const getBusinessName = () => {
        return session?.businessName;
    }

    const isAuthenticated = () => {
        return Boolean(session);
    }

    const getAvailableBusiness = () => {
        return session.accessibleBPs;
    }

    const getBusinessPartner = () => {
        if(!getIsSignedIn()) return;

        for(const bp of session.accessibleBPs) {
            if(bp.id === session.bPartnerID) {
                return bp;
            }
        }
    }

    const getBusinessCode = () => session?.businessCode;

    const isSignedIn = getIsSignedIn();
    const businessPartner = getBusinessPartner();
    const isVendor = businessPartner?.IsVendor;
    const isCustomer = businessPartner?.IsCustomer;
    // const isTobCustomer = !businessPartner?.IsInValidEOID && Boolean(businessPartner?.EO_ID);
    const isTobCustomer = isSignedIn && session?.email !== 'test@developer.com';

    return {
        sessionData: session,
        isSignedIn,
        getIsSignedIn,
        isAuthenticated,
        getUserName,
        getAvailableBusiness,
        getBusinessName,
        getBusinessCode,
        isVendor,
        isCustomer,
        isTobCustomer
    }

}

export default useSession;
